"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimsAuditTableRow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var moment = require("moment");
var components_1 = require("@athena-portal/components");
var MotorClaim_1 = require("../../model/MotorClaim");
var RentersClaim_1 = require("../../model/RentersClaim");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var services_1 = require("@falcon/services");
var ClaimsAuditTableRow = /** @class */ (function (_super) {
    __extends(ClaimsAuditTableRow, _super);
    function ClaimsAuditTableRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClaimsAuditTableRow.prototype.render = function () {
        var claimAudit = this.props.claimAudit;
        var operationName = SupportPortalTemplates_1.SupportPortalTemplates.convertOperationName(claimAudit.operation);
        return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: claimAudit.id }), (0, jsx_runtime_1.jsx)("td", { children: moment(claimAudit.auditChanged).format("DD/MM/YYYY HH:mm:ss") }), (0, jsx_runtime_1.jsx)("td", { children: operationName }), (0, jsx_runtime_1.jsx)("td", { children: claimAudit.claimId }), SupportPortalTemplates_1.SupportPortalTemplates.getProductByClaim(claimAudit) === services_1.ProductsEnum.MOTOR && (0, jsx_runtime_1.jsx)("td", { children: MotorClaim_1.default.getClaimType(claimAudit.claimTypeId) }), SupportPortalTemplates_1.SupportPortalTemplates.getProductByClaim(claimAudit) === services_1.ProductsEnum.RENTERS && (0, jsx_runtime_1.jsx)("td", { children: RentersClaim_1.default.getClaimType(claimAudit.claimTypeId) }), (0, jsx_runtime_1.jsx)("td", { children: moment(claimAudit.incidentDate).format("DD/MM/YYYY") }), (0, jsx_runtime_1.jsx)("td", { children: claimAudit.anyClaimSpend ? "yes" : "no" }), (0, jsx_runtime_1.jsx)("td", { children: claimAudit.refundAllowed ? "yes" : "no" }), (0, jsx_runtime_1.jsx)("td", { children: claimAudit.lastUpdatedBy && claimAudit.lastUpdatedBy.fullName })] }));
    };
    ClaimsAuditTableRow = __decorate([
        components_1.authorize
    ], ClaimsAuditTableRow);
    return ClaimsAuditTableRow;
}(React.Component));
exports.ClaimsAuditTableRow = ClaimsAuditTableRow;
//# sourceMappingURL=ClaimsAuditTableRow.js.map